import { useCallback, useState } from 'react';
import { readSidebarOpen, writeSidebarOpen } from '@/lib/sidebarOpen';

/**
 * The sidebar's expanded/collapsed state, persisted across reloads. Defaults
 * to expanded — `AppShell`'s own uncontrolled default before this existed.
 */
export function useSidebarOpen(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => readSidebarOpen() ?? true);

  const setSidebarOpen = useCallback((next: boolean) => {
    writeSidebarOpen(next);
    setOpen(next);
  }, []);

  return [open, setSidebarOpen];
}
